import React from 'react';
import Spinner from './Spinner';

function Button({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  className = '',
  ...props
}) {
  const baseClass = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    'outline-gold': 'btn-outline-gold',
    'outline-danger': 'border-2 border-red-600 text-red-600 px-6 py-2.5 rounded-lg font-medium hover:bg-red-600 hover:text-white transition-all duration-200',
    'outline-success': 'border-2 border-green-600 text-green-600 px-6 py-2.5 rounded-lg font-medium hover:bg-green-600 hover:text-white transition-all duration-200',
    'danger': 'bg-red-600 text-white px-6 py-2.5 rounded-lg font-medium hover:bg-red-700 transition-all duration-200'
  };

  const sizeClass = {
    sm: 'btn-sm',
    md: '',
    lg: 'btn-lg'
  };

  return (
    <button
      className={`${baseClass[variant]} ${sizeClass[size]} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <div className="flex items-center justify-center gap-2">
          <Spinner size="sm" />
          <span>Loading...</span>
        </div>
      ) : (
        children
      )}
    </button>
  );
}

export default Button;
